export const PATHS = {
  ROOT: 'users',
  ME: 'users/me',
  ME_DETAIL: 'users/me/detail',
  getOneById: (id: number) => `${PATHS.ROOT}/${id}`,
};
